<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型" prop="devClassId">
              <j-tree-select-custom
                @change="devClassChange"
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                order="sort_no asc"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
                v-model="model.devClassCode"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷部位" prop="defPart">
              <a-input placeholder="请输入缺陷部位" v-model="model.defPart"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷类别" prop="defCategory">
              <a-input placeholder="请输入缺陷类别" v-model="model.defCategory"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷等级" prop="defLevel">
              <a-radio-group button-style="solid" v-model:value="model.defLevel">
                <a-radio-button value="1">一般</a-radio-button>
                <a-radio-button value="2">严重</a-radio-button>
                <a-radio-button value="3">危急</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="缺陷类型" prop="defType">
              <a-radio-group button-style="solid" v-model:value="model.defType">
                <a-radio-button value="1">设备类</a-radio-button>
                <a-radio-button value="2">非设备类</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="设备类型名称"
              prop="devClassName"
              v-show="false"
            >
              <a-input placeholder="请输入设备类型名称" v-model="model.devClassName"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="缺陷描述"
              prop="remarks"
            >
              <a-textarea allow-clear placeholder="请输入缺陷描述" v-model="model.remarks"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'DefStandardForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false,
      },
      devClassList: {
        type: Array
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {},
        url: {
          add: "/device/defStandard/add",
          edit: "/device/defStandard/edit",
          queryById: "/device/defStandard/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    async created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      devClassChange (key, label) {
        this.model.devClassName = label
      }
    }
  }
</script>